// import { RequireAutorization } from './routerAuth'

export default {
  path: '/',
  name: 'Dashboard',
  component: () => import(/* webpackChunkName: "Dashboard" */ '@apps/dashboard/Dashboard.vue'),
  meta: { subject: 'Dashboard', action: 'read' },
}
